module.exports = __webpack_public_path__ + "img/ccic.778bafc3.png";